<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="生产商名称：">
            <el-input v-model="formInline.name" placeholder="请输入生产商名称"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
        </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="生产商ID" width="100">
        <template #default="scope">
          <div>
            <span>{{ scope.row.id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产商简称" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.shortName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="生产商全称" width="300" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.fullName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="组织机构代码" width="280" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.organizationCode }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.remark || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新建/编辑 -->
    <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.manufacturerFormRef?.clearValidate()">
        <el-form ref="manufacturerFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="manufacturerRules">
        <el-form-item label="生产商简称" prop="shortName">
            <el-input v-model="addInfo.shortName" autocomplete="off" placeholder="请输入生产商简称" />
        </el-form-item>
        <el-form-item label="生产商全称" prop="fullName">
            <el-input v-model="addInfo.fullName" autocomplete="off" placeholder="请输入生产商全称" />
        </el-form-item>
        <el-form-item label="组织机构代码" prop="organizationCode">
            <el-input v-model="addInfo.organizationCode" autocomplete="off" placeholder="请输入组织机构代码" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
            <el-input v-model="addInfo.remark" type="textarea" :rows="3" autocomplete="off" placeholder="请输入备注" />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="save()">保存</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该生产商？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteManufacturer()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { required } from '@/utils/validators';
  import Pagination from '@/components/Pagination.vue';

  export default {
  name: 'Manufacturer',
  components: {
    Pagination
  },
  data() {
    return {
      manufacturerFormRef: null,
      manufacturerRules: {
        shortName: [required('请输入生产商简称')],
        fullName: [required('请输入生产商全称')],
      },
      centerDialogVisible: false,
      currt_id: '',
      is_update: 0,
      dialogTitle: '新建生产商',
      dialogFormVisible: false,
      formInline: {
        name: ''
      },
      tableData: [],
      addInfo: {
        shortName: '',
        fullName: '',
        organizationCode: '',
        remark: ''
      },
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    filteredMessage() {
    }
  },
  beforeCreate() {
    
  },
  created() {
    
  },
  mounted() {
    this.getList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      let that = this;
      let param = {};
      param.current = that.currentPage;
      param.size = that.pageSize;
      if (that.formInline.name) {
        param.name = that.formInline.name;
      }
      that.$axios.post(that.$store.state.platformApi + "manufacturer/page", JSON.stringify(param)).then(result => {
        if (result.code == 200) {
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    showAdd() {
      this.is_update = 0;
      this.dialogTitle = '新建生产商';
      this.addInfo = {
        shortName: '',
        fullName: '',
        organizationCode: '',
        remark: ''
      };
      this.dialogFormVisible = true;
    },
    handleEdit(index, row) {
      let that = this;
      that.is_update = 1;
      that.dialogTitle = '编辑生产商';
      that.currt_id = row.id;
      that.addInfo = {
        shortName: row.shortName || '',
        fullName: row.fullName || '',
        organizationCode: row.organizationCode || '',
        remark: row.remark || ''
      };
      that.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.centerDialogVisible = true;
      this.currt_id = row.id;
    },
    save() {
      let that = this;
      that.$refs.manufacturerFormRef.validate((valid) => {
        if (!valid) return;
        
        let param = {};
        if (that.is_update == 1) {
          param.id = that.currt_id;
        }
        param.shortName = that.addInfo.shortName;
        param.fullName = that.addInfo.fullName;
        param.organizationCode = that.addInfo.organizationCode;
        param.remark = that.addInfo.remark;
        
        let apiUrl = that.is_update == 1 
          ? that.$store.state.platformApi + "manufacturer/edit"
          : that.$store.state.platformApi + "manufacturer/add";
          
        that.$axios.post(apiUrl, JSON.stringify(param)).then(result => {
          if (result.code == 200) {
            that.$message({
              message: that.is_update == 1 ? '编辑成功' : '新建成功',
              type: 'success'
            });
            that.dialogFormVisible = false;
            that.getList();
          }
        })
      });
    },
    deleteManufacturer() {
      let that = this;
      let param = {};
      param.id = that.currt_id;
      that.$axios.post(that.$store.state.platformApi + "manufacturer/del/" + param.id, {}).then(result => {
        if (result.code == 200) {
          that.$message({
            message: '删除成功',
            type: 'success'
          });
          that.getList();
          that.centerDialogVisible = false;
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-form-inline {
  margin-bottom: 10px;
}
</style>